'use client';

import { NumLib } from '@velocity-exchange/common';
import useCollateralPrice from './useCollateralPrice';

const useDisplayPrecisionForCollateral = (spotMarketIndex: number) => {
	const currentCollateralPrice = useCollateralPrice(spotMarketIndex);

	const collateralDisplayPrecision = NumLib.getDisplayPrecision(
		currentCollateralPrice
	);

	return collateralDisplayPrecision;
};

export default useDisplayPrecisionForCollateral;
